import React from 'react'
import styled from 'styled-components'
import ColorPicker from 'live/components/ui/form/color-picker'
import LiveSelect from 'live/components/forms/ui/select'
import i18n from 'live/services/i18n'

type inputTypeOptionsProps = {
    textLabel?: string | null
    inputType: 'text' | 'selector' | 'color-picker'
    placeholder?: string | null
    value?: string | null
    onChange: (event?: any) => any
    options?: any
}

export const InputType = (props: inputTypeOptionsProps): JSX.Element => {
    const { textLabel, inputType, placeholder, value, onChange, options } = props
    let Input

    if (inputType === 'text')
        Input = (
            <InputContainer>
                <input type="text" placeholder={i18n(placeholder || null)} value={value || ''} onChange={onChange} />
            </InputContainer>
        )

    if (inputType === 'selector')
        Input = (
            <LiveSelect
                placeholder={i18n(placeholder || null)}
                options={options}
                onChange={onChange}
                value={value || ''}
                clearable={false}
            />
        )

    if (inputType === 'color-picker')
        Input = (
            <ColorButton className="btn btn-edit has-icon">
                <ColorPickerLabel>
                    <ColorPicker
                        value={value || ''}
                        onChange={onChange}
                        position="absolute"
                        zIndex={5000}
                        resetColor={''}
                    />
                    <span className="text-color-picker">{i18n(value || 'Automatic')}</span>
                </ColorPickerLabel>
            </ColorButton>
        )

    return (
        <Container>
            <ConfigLabel>{i18n(textLabel || '')}</ConfigLabel>
            {Input}
        </Container>
    )
}

const ConfigLabel = styled.div`
    font-weight: 600;
    color: ${({ theme }) => theme?.['gray-800'] || '#364159'} !important;
    padding: 2px;
    margin: 0px !important;
    width: 100%;
`

const ColorPickerLabel = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme?.['gray-0'] || '#FFFFFF'};
    .form-color-picker {
        width: 100%;
        height: 100%;
    }
    .form-color-picker__toggler {
        padding: 0 8px;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        color: ${({ theme }) => theme?.['gray-700'] || '#606A80'};
        > div > div > div {
            background: none !important;
        }
    }
    .text-color-picker {
        position: absolute;
        font-size: 13px;
        height: 30px;
        line-height: 30px;
        margin-left: 32px;
        z-index: 0;
    }
    .fa-caret-down {
        color: ${({ theme }) => theme?.['gray-700'] || '#606A80'};
    }
    > span {
        max-width: 60px;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`

const ColorButton = styled.div`
    width: 100%;
    min-width: 115px;
    display: flex;
    padding: 0px;
    height: 32px;
    border: 1px solid;
    border-color: ${({ theme }) => theme?.['gray-400'] || '#C8CCD4'};
    border-radius: 3px;
    margin: 0px !important;
`

const Container = styled.div`
    width: 100%;

    .live-select {
        margin: 0px;
    }
    .Select-control {
        height: 32px;
    }
    .Select-input {
        height: 30px;
    }
    .Select-placeholder {
        line-height: 30px !important;
        color: ${({ theme }) => theme?.['gray-500'] || '#BAC0CB'};
        font-size: 12px;
        padding-left: 8px;
    }
    .Select-value {
        max-width: 95% !important;

        > span {
            > div {
                max-width: inherit;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
    }
`

const InputContainer = styled.div<{ isDisabled?: boolean }>`
    /* width: 100%; */
    /* border: 1px solid;
    border-color: ${({ theme }) => theme?.['gray-400'] || '#C8CCD4'}; */
    border: none;
    /* border-color: ${({ theme }) => theme?.['gray-400'] || '#C8CCD4'};
    :focus {
        border-color: ${({ theme }) => theme?.['blue-500'] || '#37A3EF'};
    } */

    div {
        height: 30px;
    }
    ::placeholder,
    :-ms-input-placeholder,
    ::-ms-input-placeholder,
    .Select-placeholder {
        line-height: 30px !important;
        color: ${({ theme }) => theme?.['gray-500'] || '#BAC0CB'};
        font-size: 12px;
        padding-left: 8px;
    }
    .Select-control {
        margin: 0px !important;
    }

    .Select-option {
        font-size: 12px;
        padding: 5px 8px;
    }

    .form-group,
    input[type='text'] {
        border: 1px solid;
        border-color: ${({ theme }) => theme?.['gray-400'] || '#C8CCD4'};
        :focus {
            border-color: ${({ theme }) => theme?.['blue-500'] || '#37A3EF'};
        }
        border-radius: 3px;
        margin: 0px !important;
        height: 32px;
        background-color: ${({ isDisabled, theme }) =>
            isDisabled ? theme?.['gray-400'] || '#C8CCD4' : theme?.['gray-0'] || '#FFFFFF'};
        box-shadow: none;
        ::placeholder {
            color: ${({ theme }) => theme?.['gray-500'] || '#BAC0CB'};
        }
    }

    .Select-arrow {
        /* border-color: ${({ theme }) => theme?.['blue-500'] || '#37A3EF'} transparent transparent; */
    }

    /* .select-input,
    .Select,
    .Select-control,
    .Select-placeholder,
    .Select-input {
        height: 30px;
    } */
`
